import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
  //当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
  hidden: true // (默认 false)

  //当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
  redirect: 'noRedirect'

  //当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
  //只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
  //若你想不管路由下面的 children 声明的个数都显示你的根路由
  //你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
  alwaysShow: true

  name: 'router-name' //设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
  meta: {
    roles: ['admin', 'editor'] //设置该路由进入的权限，支持多个权限叠加
    title: 'title' //设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name' //设置该路由的图标
    noCache: true //如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    breadcrumb: false // 如果设置为false，则不会在breadcrumb面包屑中显示
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    hidden: true,
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: 'dashboard', icon: 'dashboard', affix: true },
        hidden: true
      }
    ]
  },
  {
    path: '/profile', // 个人中心
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: 'profile', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/message', // 消息中心
    redirect: '/message',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/message',
        component: () => import('@/views/profile/message'),
        name: 'message',
        meta: { title: 'message' }
      }
    ]
  },
  {
    path: '/printView',
    component: () => import('@/views/order/components/printView'),
    hidden: true,
    name: 'printView' // 酒店打印
  },
  {
    path: '/printRegistration',
    component: () => import('@/views/order/components/printRegistration'),
    hidden: true,
    name: 'printRegistration' // 酒店登记表打印
  },
  {
    path: '/carPrintView',
    component: () => import('@/views/order/components/carPrintView'),
    hidden: true,
    name: 'carPrintView' // 车队打印
  }
  // {
  //   path: '/clubStock',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'clubStock',
  //   meta: {
  //     title: 'clubStock',
  //     icon: 'club',
  //     roles: ['club_stock_control']
  //   },
  //   children: [
  //     {
  //       path: 'packageManage', // 靶场套餐管理
  //       component: () => import('@/views/clubStock/packageManage'),
  //       hidden: true,
  //       name: 'package_manage',
  //       meta: {
  //         title: '靶场套餐管理'
  //       }
  //     }
  //   ]
  // }
  //
  // ,{
  //     path: '/log',
  //     component: () => import('@/views/setting/log'),
  //     redirect: 'noRedirect',
  //     name: 'log',
  //     meta: {
  //       title: '系统日志列表',
  //       icon: 'setting'
  //     }
  //   }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 *  {
    path: '/icon',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/icons/index'),
        name: 'Icons',
        meta: { title: 'Icons', icon: 'icon', noCache: true }
      }
    ]
  },
 */
export const asyncRoutes = [
  // chartsRouter,
  // {
  //   path: '/hotel',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'Hotel',
  //   id: 1,
  //   meta: {
  //     title: 'hotelInventory',
  //     icon: 'hotel',
  //     roles: ['hotel_price_stock'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: '/hotel/inventoryview',
  //       component: () => import('@/views/hotel/inventoryview'),
  //       name: 'hotel_stock', // 库存查看
  //       meta: {
  //         title: 'guideInventory'
  //         // roles: ['hotel_stock']
  //       }
  //     },
  //     {
  //       path: '/hotel/pricemanagement2',
  //       component: () => import('@/views/hotel/pricemanagement2'),
  //       name: 'garden_price_2', // 皇家花园2卧价格管理
  //       meta: {
  //         title: 'garden2',
  //         roles: ['garden_price_2']
  //       }
  //     },
  //     {
  //       path: '/hotel/pricemanagement3',
  //       component: () => import('@/views/hotel/pricemanagement3'),
  //       name: 'garden_price_3', // 皇家花园3卧价格管理
  //       meta: {
  //         title: 'garden3',
  //         roles: ['garden_price_3']
  //       }
  //     },
  //     {
  //       path: '/hotel/hourhouseprice',
  //       component: () => import('@/views/hotel/hourhouseprice'),
  //       name: 'chinatown_price', // 中国城钟点房价格管理
  //       meta: {
  //         title: 'housePrice',
  //         roles: ['chinatown_price']
  //       }
  //     }
  //     // {
  //     //   path: 'hourhouseprice2',
  //     //   component: () => import('@/views/hotel/pricemanagement24'),
  //     //   name: 'hotelhourprice24_price', // 皇家花园2卧24小时房
  //     //   meta: {
  //     //     title: 'hotelhourprice24'
  //     //     // roles: ['chinatown_price']
  //     //   }
  //     // }
  //   ]
  // },
  // {
  //   path: '/fleet',
  //   component: Layout,
  //   redirect: '/fleet/fleetview',
  //   alwaysShow: true, // will always show the root menu
  //   name: 'Hleet',
  //   meta: {
  //     title: 'fleet',
  //     icon: 'car',
  //     roles: ['car_stock_mangement'] // you can set roles in root nav
  //   },
  //   children: [
  //     {
  //       path: 'car_stock', // 车队库存
  //       component: () => import('@/views/fleet/index'),
  //       name: 'fleetView',
  //       meta: {
  //         title: 'fleetInventory',
  //         roles: ['car_stock']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/clubStock',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'clubStock',
  //   meta: {
  //     title: 'clubStock',
  //     icon: 'club',
  //     roles: ['club_stock_control']
  //   },
  //   children: [
  //     {
  //       path: '/clubStock/index', // 靶场库存管理
  //       component: () => import('@/views/clubStock/index'),
  //       name: 'club_stock',
  //       meta: {
  //         title: 'clubStock',
  //         roles: ['club_stock']
  //       }
  //     },
  //     {
  //       path: 'zhao', // 总部(赵总)库存管理
  //       component: () => import('@/views/clubStock/index_zhao'),
  //       name: 'club_stock_zhao',
  //       meta: {
  //         title: 'clubStockZhao',
  //         roles: ['club_stock_zhao']
  //       }
  //     },
  //     {
  //       path: 'daily', // 靶场库存日报
  //       component: () => import('@/views/clubStock/daily1'),
  //       name: 'club_daily',
  //       meta: {
  //         title: 'clubDaily',
  //         type: 0, // ALL
  //         roles: ['club_daily']
  //       }
  //     },
  //     {
  //       path: 'daily_zhao', // 总部库存日报
  //       component: () => import('@/views/clubStock/daily2'),
  //       name: 'club_daily_zhao',
  //       meta: {
  //         title: 'clubDailyZhao',
  //         type: 1, // 赵总
  //         roles: ['club_daily_zhao']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/hotelOrder',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   // alwaysShow: true,
  //   name: 'HotelOrder',
  //   meta: {
  //     title: 'hotelOrders',
  //     icon: 'hotel',
  //     roles: ['hotel_order']
  //   },
  //   children: [
  //     {
  //       path: 'allOrder',
  //       component: () => import('@/views/order/hotel/onlineList'),
  //       name: 'hotel_order_list', // 酒店全部订单
  //       meta: {
  //         title: 'online_order',
  //         roles: ['hotel_order_list']
  //       }
  //     },
  //     {
  //       path: 'virtualOrder',
  //       component: () => import('@/views/order/hotel/virtual'),
  //       name: 'hotel_order_virtual', // 虚拟订单
  //       meta: {
  //         title: 'virtualOrders',
  //         roles: ['hotel_order_virtual']
  //       }
  //     },
  //     {
  //       path: 'offlineOrder',
  //       component: () => import('@/views/order/hotel'),
  //       hidden: true,
  //       name: 'hotel_add', // 线下录入单
  //       meta: {
  //         title: 'offlineOrderEntry'
  //         // roles: ['hotel_order_offline']
  //       }
  //     },
  //     {
  //       path: 'offlineOrderList',
  //       component: () => import('@/views/order/hotel/offlineList'),
  //       name: 'hotel_order_offline', // 线下有效订单列表
  //       meta: {
  //         title: 'Offlinevalidorder',
  //         roles: ['hotel_order_offline']
  //       }
  //     },
  //     {
  //       path: 'invalidorders',
  //       component: () => import('@/views/order/hotel/invalidorders'),
  //       name: 'alp_offline_invalidList', // 线下无效订单
  //       meta: {
  //         title: 'Invalid_orders',
  //         roles: ['alp_offline_invalidList']
  //       }
  //     },
  //     {
  //       path: 'offlineauditorder',
  //       component: () => import('@/views/order/hotel/offline_audit_order'),
  //       name: 'alp_offline_waitList', // 线下待审核订单
  //       meta: {
  //         title: 'offline_audit_order',
  //         roles: ['alp_offline_waitList']
  //       }
  //     },
  //     {
  //       path: 'offlinetostayin',
  //       component: () => import('@/views/order/hotel/offline_to_stay_in'),
  //       name: 'alp_offline_waitUseList', // 线下待入住订单
  //       meta: {
  //         title: 'offline_to_stay_in',
  //         roles: ['alp_offline_waitUseList']
  //       }
  //     },
  //     {
  //       path: 'refundOrder',
  //       component: () => import('@/views/order/hotel/refund'),
  //       name: 'hotel_order_refund', // 酒店退款订单
  //       meta: {
  //         title: 'hotelrefundOrder',
  //         roles: ['hotel_order_refund']
  //       }
  //     },
  //     {
  //       path: '/hotelAllStatistics',
  //       name: 'hotel_all_statistics',
  //       component: () => import('@/views/statistics/hotelall'),
  //       meta: {
  //         title: 'hotelStatistics', // 酒店数据统计
  //         roles: ['hotel_statis']
  //       }
  //     },
  //     {
  //       path: '/hotelDayStatistics',
  //       name: 'hotel_day_statistics',
  //       hidden: true,
  //       component: () => import('@/views/statistics/hotelday'),
  //       meta: {
  //         title: 'hotelDayStatistics'
  //       }
  //     },
  //     {
  //       path: '/hotelAllDetail',
  //       name: 'hotel_all_detail',
  //       hidden: true,
  //       component: () => import('@/views/statistics/hotelallDetail'),
  //       meta: {
  //         title: 'hotelAllDetail'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/spaOrder',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'SpaOrder',
  //   meta: {
  //     title: 'SPAorders',
  //     icon: 'spa',
  //     // roles: ['order_management']
  //     roles: ['spa_order_list']
  //   },
  //   children: [
  //     {
  //       path: 'allOrder',
  //       component: () => import('@/views/order/spa/onlineList'),
  //       name: 'spa_order_list', // spa全部订单
  //       meta: {
  //         title: 'spaFullOrder',
  //         roles: ['spa_order_list']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/spaOrderRefund',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'SPArefundOrder',
  //   meta: {
  //     title: 'SPAorders',
  //     icon: 'spa',
  //     roles: ['spa_order_refund']
  //   },
  //   children: [
  //     {
  //       path: 'refundOrder',
  //       component: () => import('@/views/order/spa/refund'),
  //       name: 'spa_order_refund', // spa退款订单
  //       meta: {
  //         title: 'SPArefundOrder',
  //         roles: ['spa_order_refund']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/clubOrder',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'ClubOrder',
  //   meta: {
  //     title: 'rangeOrders',
  //     icon: 'club',
  //     roles: ['club_order']
  //   },
  //   children: [
  //     {
  //       path: 'allOrder', // 靶场线上订单
  //       component: () => import('@/views/order/club/onlineOrders'),
  //       name: 'club_order_list',
  //       meta: {
  //         title: 'online_order', // clubFullOrder
  //         roles: ['club_order_list']
  //       }
  //     },
  //     {
  //       path: 'refundOrder',
  //       component: () => import('@/views/order/club/refund'),
  //       name: 'club_order_refund', // 靶场退款订单
  //       meta: {
  //         title: 'clubrefundOrder',
  //         roles: ['club_order_refund']
  //       }
  //     },
  //     {
  //       path: '/offlineClubValid', // 线下有效订单
  //       component: () => import('@/views/order/club/offlineValid'),
  //       name: 'offline_club_valid',
  //       meta: {
  //         title: 'Offlinevalidorder',
  //         roles: ['offline_club_valid']
  //       }
  //     },
  //     {
  //       path: '/offlineClubValidToUse', // 线下有效订单-待到店
  //       component: () => import('@/views/order/club/offlineToUse'),
  //       name: 'offline_club_valid_tobeuser',
  //       meta: {
  //         title: 'tobeuser_orders',
  //         roles: ['offline_club_valid_tobeuser']
  //       }
  //     },
  //     {
  //       path: '/offlineClubValidOver', // 线下有效订单-已完成
  //       component: () => import('@/views/order/club/offlineOver'),
  //       name: 'offline_club_valid_over',
  //       meta: {
  //         title: 'over_orders',
  //         roles: ['offline_club_valid_over']
  //       }
  //     },
  //     {
  //       path: '/offlineClubInValid', // 线下无效订单alp/offline_club/invalidList
  //       component: () => import('@/views/order/club/offlineInValid'),
  //       name: 'offline_club_invalid',
  //       meta: {
  //         title: 'Invalid_orders',
  //         roles: ['offline_club_invalid']
  //       }
  //     },
  //     {
  //       path: '/clubOrderPackage', // 订单日报
  //       component: () => import('@/views/clubStock/order_daily'),
  //       name: 'club_order_package',
  //       meta: {
  //         title: '订单日报',
  //         // icon: 'chart',
  //         roles: ['club_daily']
  //       }
  //     },
  //     {
  //       path: '/clubPackage', // 套餐订购日报
  //       component: () => import('@/views/clubStock/package'),
  //       name: 'club_package',
  //       meta: {
  //         title: 'clubPackage',
  //         // icon: 'chart',
  //         roles: ['club_package']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/carOrder',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'CarOrder',
  //   meta: {
  //     title: 'fleetorders',
  //     icon: 'car',
  //     roles: ['car_order']
  //   },
  //   children: [
  //     {
  //       path: 'allOrder', // 车队线上订单
  //       component: () => import('@/views/order/car/onlineList'),
  //       name: 'car_order_list',
  //       meta: {
  //         title: 'online_order',
  //         roles: ['car_order_list']
  //       }
  //     },
  //     {
  //       path: 'offlineFreeOrder', // 车队线下免费订单
  //       component: () => import('@/views/order/car/offlineFreeOrder'),
  //       name: 'offline_car',
  //       meta: {
  //         title: 'offlineFreeorder',
  //         roles: ['offline_car']
  //       }
  //     },
  //     {
  //       path: 'offlineValidOrder', // 车队线下有效订单
  //       component: () => import('@/views/order/car/offlineValidOrder'),
  //       name: 'offline_car_valid',
  //       meta: {
  //         title: 'Offlinevalidorder',
  //         roles: ['offline_car_valid']
  //       }
  //     },
  //     {
  //       path: 'offlineInvalidOrder', // 车队线下无效订单
  //       component: () => import('@/views/order/car/offlineInvalidOrder'),
  //       name: 'offline_car_invalid',
  //       meta: {
  //         title: 'Invalid_orders',
  //         roles: ['offline_car_invalid']
  //       }
  //     },
  //     {
  //       path: 'carMileageList', // 车辆行驶公里列表
  //       component: () => import('@/views/order/car/carMileageList'),
  //       name: 'car_mileage',
  //       meta: {
  //         title: 'mileageList',
  //         roles: ['car_mileage']
  //       }
  //     },
  //     {
  //       path: 'carDamageList', // 车辆损坏列表
  //       component: () => import('@/views/order/car/carDamageList'),
  //       name: 'car_repair',
  //       meta: {
  //         title: 'damageList',
  //         roles: ['car_repair']
  //       }
  //     },
  //     {
  //       path: 'carMaintenance', // 车辆保养列表
  //       component: () => import('@/views/order/car/carMaintenance'),
  //       name: 'car_maintain',
  //       meta: {
  //         title: 'maintenanceList',
  //         roles: ['car_maintain']
  //       }
  //     },
  //     {
  //       path: 'carList', // 车辆列表
  //       component: () => import('@/views/order/car/carList'),
  //       name: 'car_license',
  //       meta: {
  //         title: 'vehicleList',
  //         roles: ['car_license']
  //       }
  //     },
  //     {
  //       path: 'driverList', // 司机列表
  //       component: () => import('@/views/order/car/driverList'),
  //       name: 'driver_license',
  //       meta: {
  //         title: 'driver_license',
  //         roles: ['driver_license']
  //       }
  //     },
  //     {
  //       path: 'carDailyReport', // 车辆数据日报表
  //       component: () => import('@/views/order/car/carDailyReport'),
  //       name: 'car_daily',
  //       meta: {
  //         title: 'vehicleReport',
  //         roles: ['car_daily']
  //       }
  //     },
  //     {
  //       path: 'carChart', // 车辆使用图
  //       component: () => import('@/views/order/car/carChart'),
  //       name: 'car_chart',
  //       meta: {
  //         title: 'VehicleUseDrawing',
  //         roles: ['car_chart']
  //       }
  //     },
  //     {
  //       path: 'driverDailyReport', // 司机数据日报表
  //       component: () => import('@/views/order/car/driverDailyReport'),
  //       name: 'car_driver_daily',
  //       meta: {
  //         title: 'driverReport',
  //         roles: ['car_driver_daily']
  //       }
  //     },
  //     {
  //       path: 'monthlyReport', // 月结算报表
  //       component: () => import('@/views/order/car/monthlyReport'),
  //       name: 'car_settle',
  //       meta: {
  //         title: 'monthlyStatement',
  //         roles: ['car_settle']
  //       }
  //     },
  //     {
  //       path: '/accountReport', // 查看对账单
  //       component: () => import('@/views/order/car/accountReport'),
  //       hidden: true,
  //       name: 'account_report',
  //       meta: {
  //         title: 'checkStatement'
  //       }
  //     },
  //     {
  //       path: 'refundOrder',
  //       component: () => import('@/views/order/car/refund'),
  //       name: 'car_order_refund', // 车队退款
  //       meta: {
  //         title: 'carrefundOrder',
  //         roles: ['car_order_refund']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/chinaTownOrder', // 中国城订单
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'china_town',
  //   meta: {
  //     title: 'china_town',
  //     icon: 'china',
  //     roles: ['china_town']
  //   },
  //   children: [
  //     {
  //       path: '/chinaTownOfflineValid', // 中国城订单线下有效订单
  //       component: () => import('@/views/order/chinaTown/OfflineValidOrder'),
  //       name: 'china_town_offline_valid',
  //       meta: {
  //         title: 'Offlinevalidorder',
  //         roles: ['china_town_offline_valid']
  //       }
  //     },
  //     {
  //       path: '/productManage', // 中国城 产品管理
  //       component: () => import('@/views/order/chinaTown/productManage'),
  //       name: 'product_manage',
  //       meta: {
  //         title: 'product',
  //         roles: ['product_manage']
  //       }
  //     },
  //     {
  //       path: '/chinaTownDaily', // 中国城 订单日报
  //       component: () => import('@/views/order/chinaTown/chinaTownDaily'),
  //       name: 'china_town_daily',
  //       meta: {
  //         title: 'OrderDaily',
  //         roles: ['china_town_daily']
  //       }
  //     },
  //     {
  //       path: '/chinaTownCategories', // 中国城 订单日报分类
  //       component: () => import('@/views/order/chinaTown/chinaTownCategories'),
  //       name: 'china_town_categories',
  //       meta: {
  //         title: 'OrderCategories',
  //         roles: ['china_town_categories']
  //       }
  //     },
  //     {
  //       path: '/chinaTownMonthly', // 中国城 订单月报
  //       component: () => import('@/views/order/chinaTown/chinaTownMonthly'),
  //       name: 'china_town_monthly',
  //       hidden: true,
  //       meta: {
  //         title: 'OrderMonthlyReport',
  //         roles: ['china_town_monthly']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/royalGardenOrder', // 皇家花园订单
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'royal_garden',
  //   meta: {
  //     title: 'RoyalGarden',
  //     icon: 'royal',
  //     roles: ['royal_garden']
  //   },
  //   children: [
  //     {
  //       path: '/royalGardenOrderList', // 皇家花园全部订单
  //       component: () => import('@/views/order/royalGarden/orderList'),
  //       name: 'royal_garden_list',
  //       meta: {
  //         title: 'fullOrder',
  //         roles: ['royal_garden_list']
  //       }
  //     },
  //     {
  //       path: '/royalGardenDaily', // 订单日报
  //       component: () => import('@/views/order/royalGarden/royalGardenDaily'),
  //       name: 'royal_garden_daily',
  //       meta: {
  //         title: 'OrderDaily',
  //         roles: ['royal_garden_daily']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/dataStats', // 数据统计
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   name: 'data_stats',
  //   meta: {
  //     title: 'statistics',
  //     icon: 'stats',
  //     roles: ['data_stats']
  //   },
  //   children: [
  //     {
  //       path: '/allStats', // 全部
  //       component: () => import('@/views/order/dataStats/allStats'),
  //       name: 'all_stats',
  //       meta: {
  //         title: 'all_stats',
  //         roles: ['all_stats']
  //       }
  //     },
  //     {
  //       path: '/hotelStats', // 酒店
  //       component: () => import('@/views/order/dataStats/hotelStats'),
  //       name: 'hotel_stats',
  //       meta: {
  //         title: 'hotel_stats',
  //         roles: ['hotel_stats']
  //       }
  //     },
  //     {
  //       path: '/clubStats', // 靶场
  //       component: () => import('@/views/order/dataStats/clubStats'),
  //       name: 'club_stats',
  //       meta: {
  //         title: 'club_stats',
  //         roles: ['club_stats']
  //       }
  //     },
  //     {
  //       path: '/carStats', // 车队
  //       component: () => import('@/views/order/dataStats/carStats'),
  //       name: 'car_stats',
  //       meta: {
  //         title: 'car_stats',
  //         roles: ['car_stats']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/user',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   alwaysShow: true,
  //   name: 'UserSetting',
  //   meta: {
  //     title: 'UserManagement',
  //     icon: 'user',
  //     roles: ['system_management']
  //   },
  //   children: [
  //     {
  //       path: 'manager',
  //       component: () => import('@/views/users/Administrators'),
  //       name: 'system_admin', // 管理员
  //       meta: {
  //         title: 'administrators',
  //         roles: ['system_admin']
  //       }
  //     },
  //     {
  //       path: 'writeOff',
  //       component: () => import('@/views/users/WriteOffUsers'),
  //       name: 'verification_admin', // 核销用户
  //       meta: {
  //         title: 'WriteOffUsers',
  //         roles: ['verification_admin']
  //       }
  //     },
  //     {
  //       path: 'customer',
  //       component: () => import('@/views/users/systemCustomerService'),
  //       name: 'service_admin', // 系统客服
  //       meta: {
  //         title: 'SystemCustomerService',
  //         roles: ['service_admin']
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/set',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   alwaysShow: true,
  //   name: 'systemSetting',
  //   meta: {
  //     title: 'SystemManagement',
  //     icon: 'setting',
  //     roles: ['system_management']
  //   },
  //   children: [
  //     {
  //       path: 'moduleCategory',
  //       component: () => import('@/views/setting/moduleCategory'),
  //       name: 'system_module_category', // 功能分类
  //       meta: {
  //         title: 'SetModuleCategory',
  //         roles: ['system_module_category']
  //       }
  //     },
  //     {
  //       path: 'module',
  //       component: () => import('@/views/setting/module'),
  //       name: 'system_module', // 功能管理
  //       meta: {
  //         title: 'SetModule',
  //         roles: ['system_module']
  //       }
  //     },
  //     {
  //       path: 'permission',
  //       component: () => import('@/views/setting/permission'),
  //       name: 'system_permission', // 权限管理
  //       meta: {
  //         title: 'SetPermission',
  //         roles: ['system_permission', 'permission_list']
  //       }
  //     },
  //     {
  //       path: 'role',
  //       component: () => import('@/views/setting/role'),
  //       name: 'system_role', // 角色管理
  //       meta: {
  //         title: 'setRole',
  //         roles: ['system_role']
  //       }
  //     },
  // {
  //   path: 'timedTaskType',
  //   component: () => import('@/views/setting/timedTaskType'),
  //   name: 'timed_task_type', // 定时任务类型
  //   meta: {
  //     title: 'timedTaskType'
  //   }
  // },
  // {
  //   path: 'timedTask',
  //   component: () => import('@/views/setting/timedTask'),
  //   name: 'timed_task', // 定时任务
  //   meta: {
  //     title: 'timedTask'
  //   }
  // },
  //     {
  //       path: '/setRouter',
  //       component: () => import('@/views/setting/router'),
  //       name: 'system_router',
  //       hidden: true,
  //       meta: {
  //         title: '设置路由'
  //       }
  //     }
  //   ]
  // },
  // { path: '*', redirect: '/dashboard', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
